{
  "CompatibleAtlassianProduct": [
    "CompatibleAtlassianCloudProduct",
    "CompatibleAtlassianDataCenterProduct",
    "CompatibleAtlassianServerProduct"
  ],
  "MarketplaceAppDeployment": [
    "MarketplaceCloudAppDeployment",
    "MarketplaceConnectAppDeployment",
    "MarketplaceInstructionalAppDeployment",
    "MarketplacePlugins1AppDeployment",
    "MarketplacePlugins2AppDeployment",
    "MarketplaceWorkflowAppDeployment"
  ],
  "MarketplaceAppTrustInformationResult": ["MarketplaceAppTrustInformation", "QueryError"],
  "MarketplaceStoreCurrentUserResponse": [
    "MarketplaceStoreAnonymousUser",
    "MarketplaceStoreLoggedInUser"
  ],
  "MarketplaceStoreHomePageSection": [
    "MarketplaceStoreHomePageFeaturedSection",
    "MarketplaceStoreHomePageHighlightedSection",
    "MarketplaceStoreHomePageRegularSection"
  ]
}
